import { useBusinessContext } from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchScheduledTriggerPreview, IScheduledTriggerPreviewRequest } from '../workflows'

export const queryKeyForScheduledTriggerPreview = (
  slug: string,
  payload: IScheduledTriggerPreviewRequest
) => [slug, 'workflows', 'scheduled_trigger_preview', payload]

export const useScheduledTriggerPreview = (payload: IScheduledTriggerPreviewRequest) => {
  const { slug } = useBusinessContext()

  const { data, isFetching } = useQuery({
    queryKey: queryKeyForScheduledTriggerPreview(slug, payload),
    queryFn: () => fetchScheduledTriggerPreview({ slug }, payload),
    // Next run times move with the clock, so cache only across quick config edits.
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData
  })

  return { preview: data ?? null, isLoading: isFetching }
}
